import { cacheAction } from 'vuex-cache';

import { CollectionsHelper } from '@/helpers/collections.helper';
import apiClient from '@/services/api-client';
/**
 * @template S, R
 * @typedef {import('vuex').ActionTree<S, R>} ActionTree<S, R>
 */
/**
 * @template S
 * @typedef {import('vuex').MutationTree<S>} MutationTree<S>
 */
/**
 * @template S, R
 * @typedef {import('vuex').GetterTree<S, R>} GetterTree<S, R>
 */
/**
 * @template S, R
 * @typedef {import('vuex').Module<S, R>} Module<S, R>
 */
/**
 * @typedef {import('@/store/root.state').RootState} RootState
 */

/**
 * @typedef {Object} Division
 * @property {string} id
 * @property {string} name
 * @property {boolean} can_create_projects_from_ui
 */

/**
 * @typedef {Object} SharedDivisionsState
 * @property {Division[]} divisions
 */

/** @returns {SharedDivisionsState} */
const getInitialState = () => ({
  divisions: [],
});

/** @type {SharedDivisionsState} */
const state = getInitialState();

/** @type {GetterTree<SharedDivisionsState, RootState>} */
const getters = {
  divisions: (state) => state.divisions,
};

/** @type {ActionTree<SharedDivisionsState, RootState>} */
const actions = {
  getDivisions: cacheAction(async ({ commit }) => {
    const { data } = await apiClient.divisionApi.getDivisions();

    commit('setDivisions', data);
  }),
  createDivision: async ({ commit }, divisionData) => {
    await apiClient.divisionApi.createDivision(divisionData);
    const { data } = await apiClient.divisionApi.getDivisions();

    commit('setDivisions', data);
  },
  updateDivision: async ({ commit }, { divisionId, divisionData }) => {
    await apiClient.divisionApi.updateDivision(divisionId, divisionData);
    const { data } = await apiClient.divisionApi.getDivisions();

    commit('setDivisions', data);
  },
  deleteDivision: async ({ commit }, divisionId) => {
    await apiClient.divisionApi.deleteDivision(divisionId);
    const { data } = await apiClient.divisionApi.getDivisions();

    commit('setDivisions', data);
  },
};

/** @type {MutationTree<SharedDivisionsState>} */
const mutations = {
  setDivisions: (state, divisions) => (state.divisions = CollectionsHelper.sortObjectsByProperty(divisions, 'name')),
  resetModuleState: (state) => Object.assign(state, getInitialState()),
};

/** @type {Module<SharedDivisionsState, RootState>} */
export const divisions = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

